import isEmptyString from '../../helpers/is-empty-string';
import isValidTimestamp from '../../helpers/is-valid-timestamp';
import { getUsername } from '../../helpers/rememberme-cookie-helper';
import { deleteSsiErmCookies, getSsiEnabledCookieValues } from './ssi-erm-cookie-manager';

/**
 * Check visa config for ssiOn
 * @returns {boolean} true of the value is set to 'true'
 */
export const configAllowsSSI = function() {
  const ssiOn = window?.visa?.config?.application.ssiOn ?? 'true';
  return ssiOn === 'true';
};

/**
 * Get username from ssiEbabled Cookie
 * @returns {string} activity reference id
 */
export const getUsernameFromSsiCookie = function() {
  const ssiEnabled = getSsiEnabledCookieValues();
  return (ssiEnabled && ssiEnabled.username) || null;
};

/**
 * Checks if user has valid SSI
 *  - if username cookie not matches with ssi cookie username, we need to delete all ssi/erm cookies
 * @return {boolean} true if user has valid SSI, false otherwise
 */
export const hasValidStaySignedIn = function() {
  const ssiEnabled = getSsiEnabledCookieValues() || {};
  const username = getUsername() || null;
  const ssiUsername = (ssiEnabled && ssiEnabled.username) || null;
  if (!isEmptyString(ssiUsername) && !isEmptyString(username) && username !== ssiUsername) {
    deleteSsiErmCookies();
    return false;
  }
  //TODO ssiOn config value needs to be set
  //return configAllowsSSI() && isValidTimestamp(ssiEnabled.date);
  return isValidTimestamp(ssiEnabled.date);
};
